<template>
	<div class="items-list--item">
		<b-row v-if="isListTypeCustomer" align-v="center">
			<b-col md="4">
				<div class="items-list--item-label">Job</div>
				{{ listItem.jobProfile.info }}
			</b-col>
			<b-col md="3">
				<div class="items-list--item-label">Person</div>
				{{ listItem.disclosedData.nameWithSalutation }}
			</b-col>
			<b-col md="3">
				<div class="items-list--item-label">Kontaktdaten</div>
				<div>
					<IconLink
						:text="listItem.email"
						icon="email"
						:href="'mailto:' + listItem.email"
						:with-arrow="false"
					/>
					<IconLink
						:text="listItem.phone.formatted"
						icon="phone"
						:with-arrow="false"
						:href="'tel:' + listItem.phone.full"
						class="mt-1"
					/>
				</div>
			</b-col>
			<b-col md="2">
				<div class="items-list--item-label">Datum</div>
				{{ listItem.creationDate | fullDateTime }}
			</b-col>
		</b-row>
		<b-row v-if="!isListTypeCustomer" align-v="center">
			<b-col md="4">
				<div class="items-list--item-label">Job</div>
				{{ listItem.jobProfile.info }}
			</b-col>
			<b-col md="3">
				<div class="items-list--item-label">Firma</div>
				<div>
					<a v-if="listItem.customer.website" :href="listItem.customer.website" target="_blank">
						{{ listItem.customer.website }}
					</a>
					<span v-else>{{ listItem.customer.companyName }}</span>
				</div>
				<div>{{ listItem.customer.nameWithSalutation }} ({{ listItem.customer.role }})</div>
			</b-col>
			<b-col md="3">
				<div class="items-list--item-label">Kontaktdaten</div>
				<div>
					<IconLink
						:text="listItem.customer.email"
						icon="email"
						:href="'mailto:' + listItem.customer.email"
						:with-arrow="false"
					/>
					<IconLink
						:text="listItem.customer.phone.formatted"
						icon="phone"
						:with-arrow="false"
						:href="'tel:' + listItem.customer.phone.full"
						class="mt-1"
					/>
				</div>
			</b-col>
			<b-col md="2">
				<div class="items-list--item-label">Datum</div>
				{{ listItem.creationDate | fullDateTime }}
			</b-col>
		</b-row>
	</div>
</template>

<script>
import {LIST_TYPE_CUSTOMER} from "./List"
import IconLink from "@/vue/common/IconLink";

export default {

	components: {
		IconLink
	},

	props: {
		listItem: {
			type: Object,
			required: true,
		},
		listType: {
			type: String,
			required: true,
		},
	},

	computed: {
		isListTypeCustomer ()
		{
			return this.listType === LIST_TYPE_CUSTOMER;
		}
	}
}
</script>
